import { all, put, SagaIterator, select, takeEvery } from './core/sagaEffects';
import {
    AddNotification,
    DismissNotification,
    FetchFatalError,
    NetworkConnected,
    NetworkDisconnected
} from 'acscp/actions';
import { AppState } from 'acscp/store';
import { defineMessages } from 'react-intl';
import { getTranslatableErrorMessage } from 'acscp/components/common/helpers/getTranslatableErrorMessage';
import { NotificationDuration, NotificationType } from 'acscp/store/notificationState';
import { delay } from 'redux-saga';

const messages = defineMessages({
    networkError: {
        id: 'sagas.notificationSaga.networkError',
        defaultMessage: 'Check your network connection.',
    },
});

const fetchFatalErrorCause = 'FetchFatalErrorCause';
const networkCause = 'NetworkCause';

const notificationAutoCloseTimeShort = 3000;
const notificationAutoCloseTimeLong = 7000;

export function* notificationSaga(): SagaIterator {
    yield all([
        takeEvery(AddNotification, autoCloseInfoNotification),
        takeEvery(FetchFatalError, addFetchFatalErrorNotification),
        takeEvery(NetworkConnected, removeNetworkNotification),
        takeEvery(NetworkDisconnected, addNetworkNotification),
    ]);
}

function isConnectedSelector(state: AppState): boolean {
    const stateValue = state.network.isConnected;
    return stateValue !== undefined ? stateValue : true;
}

export function* autoCloseInfoNotification(action: AddNotification): IterableIterator<any> {
    if (action.notificationType === NotificationType.Info) {
        const closeTime = action.duration === NotificationDuration.Short
            ? notificationAutoCloseTimeShort
            : notificationAutoCloseTimeLong;
        yield delay(closeTime);
        yield put(new DismissNotification(action.cause));
    }
}

export function* addFetchFatalErrorNotification(action: FetchFatalError): SagaIterator {
    const isConnected = yield select(isConnectedSelector);
    if (isConnected) {
        yield put(new AddNotification(
            fetchFatalErrorCause, getTranslatableErrorMessage(action.message), NotificationType.Error));
    }
}

export function* removeNetworkNotification(action: NetworkConnected): SagaIterator {
    yield put(new DismissNotification(networkCause));
}

export function* addNetworkNotification(action: NetworkDisconnected): SagaIterator {
    yield put(new AddNotification(networkCause, messages.networkError, NotificationType.Error));
}
